
export default {
  'orsLPolyline': {
    'type': 'Type',
    'surface': 'Surface',
    'unknownSurfaceType': 'Inconnue'
  }
}
